// userSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

// Async thunk to fetch user by slug
// Add to features/auth/authSlice.ts

export const makeOrder = createAsyncThunk(
  'userMakeOrder/makeOrder',
  async (formData: FormData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BACKEND_URL}/place-order`,
        formData,
      );

      return response.data; // Assumes { message, userData }
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || 'Failed to update user'
      );
    }
  }
);

// Define the shape of user state
interface UserState {
  user: any | null;
  loading: boolean;
  success: boolean;
  error: any | null;
}

const initialState: UserState = {
  user: null,
  loading: false,
  success: false,
  error: null
};

const userMakeOrderSlice = createSlice({
  name: 'userMakeOrder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(makeOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(makeOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = false;
      })
      .addCase(makeOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  }
});

export default userMakeOrderSlice.reducer;
